import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PRODUCTS } from '../data/farmerData';
import { WaveRule } from '../components/WaveTheme';
import './HomePage.css';

function HomePage() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const handleLookup = (e) => {
    e.preventDefault();
    const trimmed = code.trim().toUpperCase();
    if (!trimmed) {
      setError('Please enter a batch code.');
      return;
    }
    if (!PRODUCTS[trimmed]) {
      setError('No product found for this batch code. Check the code on your package and try again.');
      return;
    }
    setError('');
    navigate(`/batch/${encodeURIComponent(trimmed)}`);
  };

  return (
    <div className="wtn-home">

      <header className="wtn-nav">
        <div className="wtn-nav__inner">
          <div className="wtn-nav__brand">
            <span className="wtn-nav__mark">OUO</span>
            <div>
              <p className="wtn-nav__name">Orang Utan Organics</p>
              <p className="wtn-nav__sub">Himalayan Traceability</p>
            </div>
          </div>
        </div>
      </header>

      <main className="wtn-home__main">
        <div className="wtn-home__hero">
          <span className="wtn-eyebrow">Traceability Portal</span>
          <h1 className="wtn-h1">
            Know your food's <span className="wtn-h1__accent">journey.</span>
          </h1>
          <div className="wtn-h2-rule"><WaveRule width={110} /></div>
          <p className="wtn-home__sub">
            Enter the batch code from your package to meet the farmer, walk the field,
            and read the profile of what's inside.
          </p>

          <form className="wtn-home__form" onSubmit={handleLookup} noValidate>
            <div className="wtn-input-row">
              <input
                type="text"
                className={`wtn-input ${error ? 'is-error' : ''}`}
                placeholder="OUO_WR_47_23"
                value={code}
                onChange={(e) => { setCode(e.target.value); setError(''); }}
                autoCapitalize="characters"
                autoCorrect="off"
                spellCheck={false}
                aria-label="Batch code"
              />
              <button type="submit" className="wtn-btn wtn-btn--primary wtn-btn--large">
                Trace
              </button>
            </div>
            {error && <p className="wtn-input__error">{error}</p>}
          </form>
        </div>
      </main>

      <footer className="wtn-home__foot">
        <p>
          Powered by <span className="wtn-home__credit">TraceRoot</span>
        </p>
      </footer>

    </div>
  );
}

export default HomePage;
